class PausePlayVideo {
	constructor() {
		this.heroVideos = Array.from(document.querySelectorAll('[data-hero-video]'));

		this.heroVideos.forEach((heroVideo) => this.setupHeroVideo(heroVideo));

		if (!window.__heroVideoPopupEscBound) {
			window.addEventListener('keydown', (event) => {
				if (event.key !== 'Escape') {
					return;
				}

				const activePopup = document.querySelector('.lc-hero-video-popup.is-active');

				if (activePopup) {
					this.closePopup(activePopup);
				}
			});

			window.__heroVideoPopupEscBound = true;
		}
	}

	setupHeroVideo(heroVideo) {
		if (heroVideo.dataset.heroVideoInitialized === 'true') {
			return;
		}

		const video = heroVideo.querySelector('video');
		const toggleButton = heroVideo.querySelector('[data-hero-video-toggle]');

		if (!video || !toggleButton) {
			return;
		}

		const controlLabel = this.ensureControlLabel(toggleButton);
		this.setupPopup(heroVideo, video);

		const setPausedState = (paused) => {
			toggleButton.classList.toggle('is-play', paused);
			toggleButton.classList.toggle('is-pause', !paused);
			toggleButton.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
			toggleButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
			controlLabel.textContent = paused ? 'Play video' : 'Pause video';
		};

		let rafId = null;

    const updateRemainingProgress = () => {
      if (!Number.isFinite(video.duration) || video.duration <= 0) {
        toggleButton.style.setProperty('--progress', '0%');
        return;
      }

      const progressPercent = (video.currentTime / video.duration) * 100;
      toggleButton.style.setProperty('--progress', `${progressPercent}%`);

      rafId = requestAnimationFrame(updateRemainingProgress);
    };

		toggleButton.addEventListener('click', () => {
			if (video.paused) {
				const playPromise = video.play();

				if (playPromise && typeof playPromise.catch === 'function') {
					playPromise.catch(() => {
						setPausedState(true);
					});
				}

				return;
			}

			video.pause();
		});

		video.addEventListener('loadedmetadata', updateRemainingProgress);
		video.addEventListener('durationchange', updateRemainingProgress);
		video.addEventListener('timeupdate', updateRemainingProgress);
		video.addEventListener('seeked', updateRemainingProgress);
		video.addEventListener('pause', () => setPausedState(true));
		video.addEventListener('play', () => setPausedState(false));
		video.addEventListener('ended', () => {
			updateRemainingProgress();
			setPausedState(true);
		});

		heroVideo.dataset.heroVideoInitialized = 'true';
		setPausedState(video.paused);
		updateRemainingProgress();
	}

	setupPopup(heroVideo, heroVideoElement) {
		const popupTrigger = heroVideo.querySelector('[data-hero-video-popup-open]');

		if (!popupTrigger) {
			return;
		}

		const popupId = popupTrigger.getAttribute('data-hero-video-popup-open');
		const popup = popupId ? document.getElementById(popupId) : null;

		if (!popup) {
			return;
		}

		const popupBackground = popup.querySelector('[data-hero-video-popup-background]');
		const popupCloseButtons = Array.from(popup.querySelectorAll('[data-hero-video-popup-close]'));
		const popupStartButtons = Array.from(popup.querySelectorAll('[data-hero-video-popup-start]'));
		const popupVideo = popup.querySelector('video');

		popupTrigger.addEventListener('click', (event) => {
      event.preventDefault();

      // 👉 store BOTH reference + state
      popup.__heroVideoElement = heroVideoElement;
      popup.__wasPlaying = heroVideoElement && !heroVideoElement.paused;

      if (popup.__wasPlaying) {
        heroVideoElement.pause();
      }

      this.openPopup(popup, popupTrigger);
    });

		if (popupBackground) {
			popupBackground.addEventListener('click', () => this.closePopup(popup));
		}

		popupCloseButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.closePopup(popup);
			});
		});

		popupStartButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.startPopupVideo(popup);
			});
		});

		if (popupVideo) {
			popupVideo.addEventListener('ended', () => {
				popupVideo.controls = true;
			});
		}
	}

	openPopup(popup, popupTrigger) {
		popup.__triggerElement = popupTrigger;
		popup.classList.add('is-active');
		popup.classList.remove('is-playing');
		popup.removeAttribute('inert');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('hero-video-popup-open');

		const popupCloseButton = popup.querySelector('[data-hero-video-popup-close]');

		if (popupCloseButton) {
			requestAnimationFrame(() => {
				popupCloseButton.focus();
			});
		}

		const popupVideo = popup.querySelector('video');

		if (popupVideo) {
			popupVideo.pause();
			popupVideo.currentTime = 0;
		}
	}

	startPopupVideo(popup) {
		const popupVideo = popup.querySelector('video');

		if (!popupVideo) {
			return;
		}

		popup.classList.add('is-playing');

		const playPromise = popupVideo.play();

		if (playPromise && typeof playPromise.catch === 'function') {
			playPromise.catch(() => {
				popup.classList.remove('is-playing');
			});
		}
	}

	closePopup(popup) {
	if (popup.contains(document.activeElement)) {
		const trigger = popup.__triggerElement;

		if (trigger && typeof trigger.focus === 'function') {
			trigger.focus();
		} else if (document.activeElement && typeof document.activeElement.blur === 'function') {
			document.activeElement.blur();
		}
	}

	popup.classList.remove('is-active');
	popup.classList.remove('is-playing');
	popup.setAttribute('aria-hidden', 'true');
	popup.setAttribute('inert', '');
	document.body.classList.remove('hero-video-popup-open');

	const popupVideo = popup.querySelector('video');

	if (popupVideo) {
		popupVideo.pause();
		popupVideo.currentTime = 0;
	}

	const heroVideoElement = popup.__heroVideoElement;

  if (heroVideoElement && popup.__wasPlaying) {
    const playPromise = heroVideoElement.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }
}

	ensureControlLabel(toggleButton) {
		let controlLabel = toggleButton.querySelector('.lc-hero-video__control-label');

		if (!controlLabel) {
			controlLabel = document.createElement('span');
			controlLabel.className = 'lc-hero-video__control-label';
			toggleButton.append(controlLabel);
		}

		return controlLabel;
	}
}

export default PausePlayVideo;

